import type { Nullish } from '@iheartjane/types';
import type { AggregateRating, Review } from 'schema-dts';

/** @see https://developers.google.com/search/docs/appearance/structured-data/review-snippet */

interface Rated {
  aggregate_rating?: Nullish<number>;
  review_count?: Nullish<number>;
}

/** @see https://schema.org/AggregateRating */
export const aggregateRating = ({
  aggregate_rating,
  review_count,
}: Rated): { aggregateRating: AggregateRating } | Record<string, never> => {
  return aggregate_rating &&
    aggregate_rating >= 1 &&
    review_count &&
    review_count > 0
    ? {
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: aggregate_rating,
          reviewCount: review_count,
        },
      }
    : {};
};

interface JaneProductReview {
  comment?: string;
  created_at?: string;
  nickname?: string;
  rating?: number;
}

/** @see https://schema.org/Review */
export const reviews = (
  reviews: JaneProductReview[] = []
): { review: Review[] } | Record<string, never> => {
  const eligibleReviews = reviews.filter(
    ({ nickname, rating }) => rating !== undefined && nickname !== undefined
  );
  if (eligibleReviews.length === 0) {
    return {};
  }

  return {
    review: eligibleReviews.map(
      ({ comment, created_at, nickname, rating }) => ({
        '@type': 'Review',
        reviewBody: comment,
        datePublished: created_at,
        author: {
          '@type': 'Person',
          name: nickname,
        },
        reviewRating: {
          '@type': 'Rating',
          ratingValue: rating,
        },
      })
    ),
  };
};
